import React from 'react';
export function PrivacyPolicy() {
  return <div className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-1156">
      <h1 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-1157">Privacybeleid</h1>

      <div className="space-y-8 text-gray-700" data-id="element-1158">
        <section data-id="element-1159">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1160">1. Inleiding</h2>
          <p data-id="element-1161">
            De Maekerij hecht veel waarde aan de bescherming van uw
            persoonsgegevens. In dit privacybeleid leggen we uit welke gegevens
            we verzamelen, waarom we dit doen en hoe we hiermee omgaan.
          </p>
        </section>

        <section data-id="element-1162">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1163">
            2. Welke gegevens verzamelen we?
          </h2>
          <p className="mb-4" data-id="element-1164">
            Wij verzamelen persoonsgegevens die u ons verstrekt bij:
          </p>
          <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1165">
            <li data-id="element-1166">
              Het inschrijven voor een workshop (naam, e-mail, telefoonnummer)
            </li>
            <li data-id="element-1167">Het inschrijven op onze nieuwsbrief (e-mailadres)</li>
            <li data-id="element-1168">
              Het huren van een locatie (bedrijfsgegevens, contactpersoon)
            </li>
            <li data-id="element-1169">Het contact opnemen via ons contactformulier</li>
          </ul>
        </section>

        <section data-id="element-1170">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1171">
            3. Doeleinden
          </h2>
          <p data-id="element-1172">Wij gebruiken uw gegevens uitsluitend voor:</p>
          <ul className="list-disc pl-5 space-y-2 mt-4" data-id="element-1173">
            <li data-id="element-1174">Het verwerken van uw inschrijving of boeking</li>
            <li data-id="element-1175">Communicatie over uw boeking (bevestiging, wijzigingen)</li>
            <li data-id="element-1176">Het versturen van onze nieuwsbrief (indien aangemeld)</li>
            <li data-id="element-1177">Het beantwoorden van uw vragen</li>
            <li data-id="element-1178">Wettelijke verplichtingen (zoals boekhouding)</li>
          </ul>
        </section>

        <section data-id="element-1179">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1180">
            4. Delen met derden
          </h2>
          <p data-id="element-1181">
            Wij delen uw gegevens niet met derden voor commerciële doeleinden.
            Wij delen gegevens alleen met partijen die noodzakelijk zijn voor
            onze dienstverlening (zoals betaalproviders of boekhoudsoftware), en
            alleen de strikt noodzakelijke gegevens.
          </p>
        </section>

        <section data-id="element-1182">
          <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1183">
            5. Uw rechten
          </h2>
          <p data-id="element-1184">
            U heeft het recht om uw gegevens in te zien, te corrigeren of te
            laten verwijderen. Neem hiervoor contact met ons op via
            welkom@demaekerij.be.
          </p>
        </section>
      </div>
    </div>;
}